var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('upModel',{staticClass:"pre-consult-rule-model-container",attrs:{"title":"服务说明","show":_vm.value,"showCloseBtn":true,"autoHeight":true,"buttons":_vm.clickToLink
      ? [
          {
            label: '马上预约',
            desc: '咨询预沟通最低29.9元/次',
            onClick: function () { return _vm.$emit('toPreConsult'); }
          }
        ]
      : [
          {
            label: '我知道了',
            onClick: function () { return _vm.$emit('input', false); }
          }
        ]},on:{"close":_vm.close}},[_c('div',{staticClass:"pre-consult-rule-model"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])}
var staticRenderFns = []

export { render, staticRenderFns }